import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

import {DropdownSelectComponent} from '../../../../layout/dropdown-select/dropdown-select.component';
import {
  DropdownSelectOptionComponent
} from '../../../../layout/dropdown-select-option/dropdown-select-option.component';
import {LangService} from '../../../../../services/language/lang.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';

@Component({
  selector: 'app-language-form',
  imports: [
    ReactiveFormsModule,
    DropdownSelectComponent,
    DropdownSelectOptionComponent
],
  templateUrl: './language-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './language-form.component.scss'
})
export class LanguageFormComponent implements Dialog {
  loaded = false;
  languages: string[] = [];

  form = new FormGroup({
    language: new FormControl('', Validators.required),
  });

  constructor(
    private loader: LoaderService,
    private dialogService: DialogService,
    private snackbar: SnackbarService,
    protected langService: LangService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.loader.startLoading();
    this.langService.getAllLanguages().subscribe(languages => {
      this.languages = languages.filter(language => {
        // Filter known languages
        return this.langService.getName(language) !== language;
      }).sort((a, b) => {
        let langA = this.langService.getName(a) ?? '';
        let langB = this.langService.getName(b) ?? '';
        return langA.localeCompare(langB);
      });
      this.loader.stopLoading();
      this.loaded = true;
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    const params: any = this.form.value;

    this.loader.startLoading();
    this.langService.create(params.language).subscribe(() => {
      this.snackbar.success('Language has been added.');
      this.loader.stopLoading();
      this.dialogService.closeDialog();
    });
  }
}
